import { SagaIterator } from 'redux-saga';
import { put } from 'redux-saga/effects';

import { requestFailed } from '~src/app/actions/RequestFailedAction';
import { setOrderAction } from '~src/app/actions/SetOrderAction';
import { enterSpace } from '~src/app/actions/spaces/EnterSpaceAction';
import { requestSpaceContents } from '~src/app/actions/spaces/RequestSpaceContentsActions';
import { getOrderClausesFromQueryParam } from '~src/app/spaces/Explorer/ExplorerUrlBindings';
import { SpaceInfo } from '~src/app/state/SpaceInfo';
import { UrlParamKeys } from '~src/app/UrlParamKeys';
import { Messages } from '~src/codegen/Localize';
import { WindowLocationService } from '~src/commonInfra/services/WindowLocationService';
import { getDefaultOrderForPublishedConnectionSubSpace } from '~src/ts/models/sort/SortOptionDefinitions';

import { EnterPublishedConnectionSubspaceReduxAction } from '../actions/EnterPublishedConnectionSubspaceAction';

export function* handleEnterPublishedConnectionSubspace(action: EnterPublishedConnectionSubspaceReduxAction): SagaIterator {
  try {
    const spaceInfo: SpaceInfo = {
      item: action.publishedConnectionDetailInfo,
      spaceType: 'publishedConnection',
      subspaceName: action.subspaceName,
    };
    yield put(enterSpace(spaceInfo));
    if (action.requestContent) {
      const hashQuery: any = WindowLocationService.getHashQueryObject();
      const orderFromQuery = getOrderClausesFromQueryParam(
        hashQuery[UrlParamKeys.Order],
        getDefaultOrderForPublishedConnectionSubSpace(spaceInfo)
      );
      yield put(setOrderAction(orderFromQuery));
      yield put(requestSpaceContents());
    }
  } catch (e) {
    yield put(requestFailed(e, Messages.unexpectedError()));
  }
}
